import ProjectUserCardComponent from './project-user-card.component'

const ProjectUserCardModule = angular.module('cdbl.project-user-card', [

])
  .component('cdblProjectUserCard', ProjectUserCardComponent)
  .name

export default ProjectUserCardModule
